import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=a4276cf6"
import script from "./LinkList.vue?vue&type=script&lang=js"
export * from "./LinkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports